import CONSTANT from '../../constant';
import { requestExt } from '../../util';
import { mscratch } from './index';

/**
 * 加载扩展
 *
 * @param {any} extInfo
 * @param {boolean} [isSelected=false]
 * @param {any} callback
 */
const loadExt = async (extInfo, isSelected = false, isAbsolutePath = false) => {
    const scratchExt = ['pen', 'music'];
    try {
        if (scratchExt.indexOf(extInfo.id.toLowerCase()) !== -1) {
            mscratch.extensions.loadScratchExtension(extInfo.id);
        } else {
            const ext = await requestExt(extInfo.main, isAbsolutePath, extInfo.id);
            // TODO: need check ext.default
            mscratch.extensions.load(extInfo.id, ext.default, isSelected);
        }
        return true;
    } catch (error) {
        console.warn(error);
        return false;
    }
};


/**
 * 移除扩展
 *
 * @author LiHuan
 * @param {any} extId
 */
const unloadExt = (extId) => {
    return mscratch.extensions.unload(extId);
};

/**
 * 获取设备列表
 *
 * @param {string} [id=CONSTANT.DEVICE.CODEY]
 * @returns
 */
export const getTargetDevices = () => {
    const allTargets = mscratch.extensions.getAllTargets();
    let res = [];
    allTargets.forEach(target => {
        if (target.isScratch !== true) {
            res = res.concat(
                target.scratchTargtes
                    .map(scratchTarget => {
                        const name = scratchTarget.name || scratchTarget.sprite.name;
                        const deviceId = target.deviceId;
                        return { id: scratchTarget.id, name, deviceId };
                    })
            );
        }
    });
    return res;
};

/**
 * 获取当前正在编辑的设备
 *
 * @returns 当前设备
 */
export const editingTarget = () => {
    if (mscratch && mscratch.extensions) {
        const target = mscratch.extensions.getEditingTarget();
        if (target) {
            return target;
        }
    }
    return { id: CONSTANT.DEVICE.CODEY };
};

/**
 * 是否使用扩展下面的 block
 *
 * @param {any} type
 */
export const hasUseExtBlocks = (extType) => {
    return mscratch.extensions.isBlocksUsed(extType);
};


/**
 * 当前设备加载的扩展
 *
 * @returns
 */
export const curTargetExts = () => {
    return mscratch.extensions.getEditingTargetExtensionIds();
};

/**
 * codey是否已加载
 *
 * @returns
 */
export const isCodeyLoaded = () => {
    return mscratch.extensions.getTarget('codey');
};

/**
 * 当更新固件时
 *
 * @returns
 */
export function beforeFirmwareUpload () {
    mscratch.extensions.beforeFirmwareUpload();
}

/**
 * 获取设备的配置项
 */
export const getDeviceConfig = () => {
    const device = editingTarget();
    return device.config;
};

export {
    loadExt,
    unloadExt
};